<div
  ngbDropdown
  class="d-block w-100 dropdown-container"
  #dropdown="ngbDropdown"
  container="body"
  (openChange)="openChange($event)"
>
  <button
    type="button"
    class="btn btn-{{
      size()
    }} form-control text-truncate w-100 pe-4 text-start"
    ngbDropdownToggle
    #dropdownToggle
    [disabled]="disabled()"
    [ngClass]="{
      'control-status-danger':
        status() === 'danger' && !disabled() && value().length,
      'control-status-success':
        status() === 'success' && !disabled() && value().length,
    }"
    (click)="onToggle()"
  >
    {{ label() || placeholder() | translate }}
    @if (isOpen()) {
      <i class="fa fa-chevron-up fa-xs ps-2"></i>
    } @else {
      <i class="fa fa-chevron-down fa-xs ps-2"></i>
    }
  </button>
  <div
    ngbDropdownMenu
    #dropdownMenu
    class="dropdown-menu border"
    [style.--multi-select-min-width.px]="buttonWidth()"
  >
    @if (header()) {
      <div class="dropdown-header">
        <input
          type="text"
          class="form-control"
          [placeholder]="'shared.select.searchPlaceholder' | translate"
          [value]="searchValue()"
          (keyup)="search($event.target.value)"
        />
      </div>
      <div class="dropdown-divider"></div>
    }
    <div class="checkbox-wrapper text-nowrap px-3 pt-1">
      <ng-content select="app-multi-select-checkbox"></ng-content>
      <ng-content select=".group">
        <ng-content select="app-multi-select-checkbox"></ng-content>
      </ng-content>
    </div>
    @if (footer()) {
      <div class="dropdown-divider"></div>
      <div class="dropdown-footer">
        <div class="d-flex gap-2">
          <button
            class="btn btn-outline-primary w-100 ms-3 my-2"
            (click)="clear()"
          >
            {{ 'shared.multiSelect.clear' | translate }}
          </button>
          <button class="btn btn-primary w-100 me-3 my-2" (click)="apply()">
            {{ 'shared.multiSelect.apply' | translate }}
          </button>
        </div>
      </div>
    }
  </div>
</div>
